import React, { useState } from 'react';
import ImageGallery from 'react-image-gallery';
import noAvailablePicture from '../../assets/utils/NopictureAvailable.png';
import 'react-image-gallery/styles/css/image-gallery.css';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  makeStyles,
} from '@material-ui/core';
import {
  Close as CloseIcon,
  ChevronLeft,
  ChevronRight,
} from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  customArrow: {
    background: 'rgba(0, 0, 0, 0.3)',
    border: 'none',
    borderRadius: '50%',
    color: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    opacity: 0.6,
    transition: 'opacity 0.3s ease',
    '&:hover': {
      opacity: 0.9,
    },
    '&:disabled': {
      opacity: 0.3,
      cursor: 'not-allowed',
    },
  },
}));

interface Image {
  original: string;
  thumbnail: string;
}
export default function Carousel({ images }) {
  const classes = useStyles();
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string>('');

  const treatedImages: Image[] = [];
  if (images?.length > 0) {
    images.forEach((e: string, index) => {
      treatedImages[index] = {
        original: e,
        thumbnail: e,
      };
    });
  } else {
    treatedImages[0] = {
      original: noAvailablePicture,
      thumbnail: noAvailablePicture,
    };
  }

  const handleImageClick = (event: any) => {
    setSelectedImage(event.target.src);
    setPopupOpen(true);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
    setSelectedImage('');
  };

  const renderLeftNav = (onClick, disabled) => {
    return (
      <button
        className={classes.customArrow}
        onClick={onClick}
        disabled={disabled}
        style={{
          position: 'absolute',
          left: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1,
        }}
      >
        <ChevronLeft fontSize="small" />
      </button>
    );
  };

  const renderRightNav = (onClick, disabled) => {
    return (
      <button
        className={classes.customArrow}
        onClick={onClick}
        disabled={disabled}
        style={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1,
        }}
      >
        <ChevronRight fontSize="small" />
      </button>
    );
  };

  return (
    <div>
      <ImageGallery
        showFullscreenButton={false}
        showPlayButton={false}
        items={treatedImages}
        stopPropagation={true}
        disableKeyDown={true}
        onErrorImageURL={noAvailablePicture}
        onClick={handleImageClick}
        renderLeftNav={renderLeftNav}
        renderRightNav={renderRightNav}
        infinite={false}
      />

      <Dialog
        open={popupOpen}
        onClose={handleClosePopup}
        maxWidth="lg"
        fullWidth
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <DialogContent
          style={{
            padding: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'transparent',
          }}
        >
          <Box position="relative" display="inline-block">
            <IconButton
              aria-label="close"
              onClick={handleClosePopup}
              style={{
                position: 'absolute',
                right: 8,
                top: 8,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                color: 'white',
                zIndex: 1000,
              }}
            >
              <CloseIcon />
            </IconButton>
            <img
              src={selectedImage}
              alt="Full size"
              style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                objectFit: 'contain',
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}
